import React from 'react';
import { Home, Plus, MessageSquare, User } from 'lucide-react';
import { useTheme } from '../context/ThemeContext.tsx';

interface MobileNavigationProps {
    activeTab: 'home' | 'create' | 'chats' | 'profile';
    onHome?: () => void;
    onCreateCharacter?: () => void;
    onShowChats?: () => void;
    onProfile?: () => void;
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({
    activeTab,
    onHome,
    onCreateCharacter,
    onShowChats,
    onProfile
}) => {
    const { isDarkMode } = useTheme();

    const NavItem = ({
        icon: Icon,
        label,
        isActive,
        onClick
    }: {
        icon: any;
        label: string;
        isActive: boolean;
        onClick?: () => void;
    }) => (
        <button
            onClick={onClick}
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '4px',
                flex: 1,
                padding: '8px 0',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: isActive
                    ? '#a855f7'
                    : (isDarkMode ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)'),
                transition: 'all 0.2s ease'
            }}
        >
            <Icon size={24} strokeWidth={isActive ? 2.5 : 2} />
            <span style={{
                fontSize: '10px',
                fontWeight: isActive ? '600' : '400'
            }}>
                {label}
            </span>
        </button>
    );

    return (
        <nav style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            height: '64px',
            backgroundColor: isDarkMode ? 'rgba(26, 26, 46, 0.95)' : 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
            borderTop: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around',
            zIndex: 9999,
            paddingBottom: 'env(safe-area-inset-bottom, 0)'
        }}>
            <NavItem
                icon={Home}
                label="Home"
                isActive={activeTab === 'home'}
                onClick={onHome}
            />
            <NavItem
                icon={Plus}
                label="Create"
                isActive={activeTab === 'create'}
                onClick={onCreateCharacter}
            />
            <NavItem
                icon={User}
                label="Profile"
                isActive={activeTab === 'profile'}
                onClick={onProfile}
            />
        </nav>
    );
};

export default MobileNavigation;
